import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { Box, Card, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';

import logoEuroansa from '../../assets/images/favicon-euroansa.png';
import logoTassomutuo from '../../assets/images/logo_tassomutuo.png';
import illustration from '../../assets/images/italia_oltre.png';
import { useQueryParam } from '../../hooks';
import { CtaButton, TextInput } from '@tassomutuo-backoffice/ui';
import { toast } from 'react-toastify';
import {
  setApiTokensInLocalStorage,
  setUserInLocalStorage,
} from '../../services/localStorage/localStorage';
import {
  googleLogin as googleLoginRequest,
  login,
} from '../../services/api/auth/auth';
import { useNavigate } from 'react-router-dom';
import { logMixPanelEvent } from '../../services/tracking/mixPanel';

const LoginPage = () => {
  const query = useQueryParam();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showEmailForm, setShowEmailForm] = useState(false);

  const navigate = useNavigate();

  const navigateAfterLogin = () => {
    logMixPanelEvent('user login');
    const redirectTo = query.get('from');
    navigate(redirectTo || '/lead');
  };

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: (data, variables, context) => {
      setApiTokensInLocalStorage(data.tokens);
      setUserInLocalStorage(data.user);
      navigateAfterLogin();
    },
    onError: (error) => {
      toast.error(
        error.message || 'Si è verificato un errore, per favore riprova!'
      );
    },
  });

  const googleLoginMutation = useMutation({
    mutationFn: googleLoginRequest,
    onSuccess: (data, variables, context) => {
      setApiTokensInLocalStorage(data.tokens);
      setUserInLocalStorage(data.user);
      navigateAfterLogin();
    },
    onError: (error) => {
      const errMessage = error.message;
      toast.error(
        errMessage || 'Si è verificato un errore, per favore riprova!'
      );
    },
  });

  const performLogin = () => {
    const dataToSend = {
      email,
      password,
    };
    mutation.mutate(dataToSend);
  };

  const googleLogin = useGoogleLogin({
    onSuccess: ({ code }) => {
      googleLoginMutation.mutate({ code });
    },
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/calendar',
  });

  return (
    <Box display="flex" minHeight="100vh" position="relative">
      <Box
        position="fixed"
        top={0}
        left={0}
        width="40px"
        height="40px"
        onClick={() => setShowEmailForm(true)}
        sx={{ cursor: 'default', zIndex: 9999 }}
      />
      <Box
        display={{ xs: 'none', lg: 'flex', objectFit: 'contain' }}
        component="img"
        src={illustration}
        alt=""
        flex={1}
      />
      <Box flex={1} display="flex" justifyContent="center" alignItems="center">
        <Card sx={{ width: '100%', maxWidth: '500px' }}>
          <Box
            //mx={2}
            //mt={-3}
            p={2}
            mb={1}
            textAlign="center"
            sx={{
              bgcolor: (th) => th.palette.primary.dark,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box component="img" src={logoTassomutuo} width="80%"></Box>

            <Typography variant="h6" fontWeight="medium" color="white">
              Backoffice
            </Typography>
          </Box>
          <Box pt={4} pb={3} px={3}>
            <Box component="form" role="form" style={{ display: showEmailForm ? 'block' : 'none' }}>
              <Box mb={2}>
                <TextInput
                  type="email"
                  label="Email"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(e.target.value);
                  }}
                />
              </Box>
              <Box mb={2}>
                <TextInput
                  type="password"
                  label="Password"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setPassword(e.target.value);
                  }}
                />
              </Box>
              <Box mt={4} mb={1}>
                <CtaButton
                  sx={{ width: '100%' }}
                  variant="contained"
                  onClick={performLogin}
                >
                  Accedi
                </CtaButton>
              </Box>
            </Box>
            <Box mt={0} display="flex" justifyContent="space-evenly">
              <Box display="flex" flexDirection="column" alignItems="center">
                <Box
                  onClick={googleLogin}
                  sx={{
                    border: '1px solid lightgray',
                    borderRadius: '10px',
                    padding: '0 20px 0 15px',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Box
                    component="img"
                    src={logoEuroansa}
                    alt="logo-euroansa"
                    width="35px"
                    height="35px"
                  /> 
                  Accedi con Euroansa
                </Box>
              </Box>

              {/* <Box display="none" flexDirection="column" alignItems="center">
                <Box
                  onClick={googleLogin}
                  sx={{
                    border: '1px solid lightgray',
                    borderRadius: '100%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Box
                    component="img"
                    src={logoGoogle}
                    alt="logo-google"
                    width="25px"
                    height="25px"
                  />
                </Box>
                <Typography variant="body2">Google</Typography>
              </Box> */}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default LoginPage;
